import i18n from "../i18n";
import {
  STATUS_ACTIVE,
  STATUS_QUALIFIED,
  SUBSTATUS_READY_FOR_WORK,
  SUBSTATUS_ONBOARDING_REQUEST,
  SUBSTATUS_UNDER_VALIDATION,
  SUBSTATUS_AGREEMENT_SENT,
  SUBSTATUS_ONBOARDING_DONE,
} from "./constantValues";

export const validateEmail = (value = "") => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !emailRegex.test(value) ? i18n.t("invalidEmail") : null;
};

export const isValidEmail = (email) => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return !!emailRegex.test(email);
};
export function scrollIntoView(id) {
  document.getElementById(id)?.scrollIntoView?.({
    behavior: "smooth",
    block: "end",
  });
}

export const canAccessFinancialDetails = (userDetails = {}) => {
  const { status, subStatus } = userDetails;

  const urgentActive =
    status === STATUS_ACTIVE && subStatus === SUBSTATUS_READY_FOR_WORK;

  const qualifiedOnboarding =
    status === STATUS_QUALIFIED &&
    [
      SUBSTATUS_ONBOARDING_REQUEST,
      SUBSTATUS_UNDER_VALIDATION,
      SUBSTATUS_AGREEMENT_SENT,
      SUBSTATUS_ONBOARDING_DONE,
    ].includes(subStatus);

  return urgentActive || qualifiedOnboarding;
};
